import React from "react"
import {
  container, innerContainer,
  icon as s_icon, copyright,
  two, phoneNumbers, footerColumn,
  three
} from "./footer.module.css"
import icon from "src/images/icon.png"
import { Link } from "gatsby"
import classnames from "classnames"

const Footer = () => {
  return (
    <>
      <div className={ container }>
        <div className={ innerContainer }>
          <div className={ footerColumn }>
            <div>
              <figure>
                <img className={ s_icon } src={ icon } alt="logo" />
              </figure>
              <address>
                Westbury Farm, Upminster
                <br />
                RM14 3NU
              </address>
            </div>
            <p className={ copyright }>
              © Copyright 2020 TAG Supplies Ltd. All Rights Reserved
            </p>
          </div>
          <div className={ classnames( footerColumn, two ) }>
            <h1>Get in Touch</h1>
            <address>
              <a href="mailto:info@tagsupplies.com">info@tagsupplies.com</a>
            </address>
            <div className={ phoneNumbers }>
              <p>
                Office - <a href="tel:+44 208 0043955">+44 208 0043955</a>{ " " }
                (8am-5pm)
              </p>
              <p>
                Tom - <a href="tel:+44 07941964743">+44 07941964743</a>
              </p>
              <p>
                Giles - <a href="tel:+44 07914406327">+44 07914406327</a>
              </p>
            </div>
          </div>
          <div className={ classnames( footerColumn, three ) }>
            <h1>Learn more</h1>
            <Link to="/about-us">About Us</Link>
            <Link to="/equipment">Equipment</Link>
            <Link to="/services">Services</Link>
          </div>
        </div>
      </div>
    </>
  )
}

export default Footer
